import { Button } from 'devextreme-react/button';
import { Popover } from 'devextreme-react/popover';
import { useNavigate } from 'react-router-dom';
import { useGetCompany } from '../../../../api/company';
import { StatisticsItem } from '../../../../api/statistics';
import { useAuth } from '../../../../contexts/auth';
import { BusinessFlow } from '../../../../types/enums';
import '../../../common/action-required-card/components/ActionRequiredCard.scss';


export default function PendingChangeOrdersCard(props: { statData: StatisticsItem[], description?: string }) {

    const { user } = useAuth();
    const company = useGetCompany(user?.companyId);
    const useCorporateToApproveAR = !!company.data?.assignedRetailers
        .find(x => x.businessFlowID === BusinessFlow.CTG || x.businessFlowID === BusinessFlow.Online);

    const integrationWithIME = !!company.data?.assignedRetailers.find(x => x.IME);

    const navigate = useNavigate();

    const totalCount = props.statData.find(x => x.statID === 10100)?.total ?? 0;
    const pendingDealerCount = props.statData.find(x => x.statID === 10110)?.total ?? 0;
    const pendingCustomerCount = props.statData.find(x => x.statID === 10120)?.total ?? 0;
    const pendingSageCount = props.statData.find(x => x.statID === 10130)?.total ?? 0;
    const pendingCorporateCount = props.statData.find(x => x.statID === 10140)?.total ?? 0;
    const infoElementID = "ar-info-pending-change-orders";

    return (
        <div className='ar-button not-mine-ar-button dx-card'>
            <div className='ar-text ar-text-multiline'>Pending Change Orders</div>
            <div className='ar-total'>
                <span>{totalCount}</span>
                <i className='dx-icon dx-icon-Inscyth-Info' id={infoElementID}></i>
            </div>
            <Popover
                target={'#' + infoElementID}
                showEvent='dxhoverstart'
                hideEvent='dxhoverend'
                width={300}
            >
                {
                    <div className='ar-description'>
                        <div>
                            {integrationWithIME ?
                                "Pending Dealer: Change Orders awaiting Lowe's for customer payment or approval." :
                                "Pending Dealer: Change Orders awaiting for dealer to confirm the change order."}
                        </div>
                        {
                            integrationWithIME &&
                            <div>
                                Pending Customer Payment: Change Orders awaiting customer's final payment.
                            </div>
                        }
                        {
                            integrationWithIME &&
                            <div>
                                Pending Sage: Change Orders awaiting Sage to address discrepancies or validate pricing or confirm the change order accepted by corporate.
                            </div>
                        }
                        {
                            useCorporateToApproveAR &&
                            <div>
                                Pending Sage: Change Orders awaiting for Sage to confirm the change order accepted by corporate.
                            </div>
                        }
                        {
                            useCorporateToApproveAR &&
                            <div>
                                Pending Corporate: Change Orders awaiting for corporate to accept the change order.
                            </div>
                        }
                    </div>
                }
            </Popover>
            <>
                <Button onClick={() => navigate('/cfi/change-orders/dealer')}>
                    <div className="button-text">
                        Pending Dealer <br />
                        <b>{pendingDealerCount}</b>
                    </div>
                </Button>
                {
                    integrationWithIME &&
                    <Button onClick={() => navigate('/cfi/change-orders/customer')}>
                        <div className="button-text">
                            Pending Customer Payment<br />
                            <b>{pendingCustomerCount}</b>
                        </div>
                    </Button>
                }
                {
                    (integrationWithIME || useCorporateToApproveAR) &&
                    <Button onClick={() => navigate('/cfi/change-orders/sage')}>
                        <div className="button-text">
                            Pending Sage<br />
                            <b>{pendingSageCount}</b>
                        </div>
                    </Button>
                }
                {
                    useCorporateToApproveAR &&
                    <Button onClick={() => navigate('/cfi/change-orders/corporate')}>
                        <div className="button-text">
                            Pending Corporate<br />
                            <b>{pendingCorporateCount}</b>
                        </div>
                    </Button>
                }
            </>
        </div>
    )
} 
